/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { InfiniteMatDataSource } from '@gh/common-external-shared';
import { openInNewWindow } from '@gh/core-util';
import { SupplierSharedDocsListBusinessService } from '../../resources';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../resources";
import * as i3 from "../../../common-external-shared/components/ext-page/ext-page.component";
import * as i4 from "@angular/material/sort";
import * as i5 from "../../../common-external-shared/directives/ext-if-query.directive";
import * as i6 from "../../../common-external-shared/components/ext-load-tracker/ext-load-tracker.component";
import * as i7 from "@angular/flex-layout/flex";
import * as i8 from "@angular/material/table";
import * as i9 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-table.directive";
import * as i10 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-table-viewer.directive";
import * as i11 from "@angular/material/button";
import * as i12 from "../../../common-external-shared/infinite-scroll/table/ext-infinite-row.directive";
import * as i13 from "../../../common-external-shared/infinite-scroll/list/ext-infinite-list.component";
import * as i14 from "../../../common-external-shared/infinite-scroll/list/ext-infinite-scroll-for.directive";
import * as i15 from "@angular/material/card";
import * as i16 from "../../../core-mls/translation/translate.pipe";
function SupplierSharedDocsListComponent_mat_table_5_mat_header_cell_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-header-cell", 15);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(2, 1, "lbl_file_name"));
} }
function SupplierSharedDocsListComponent_mat_table_5_mat_cell_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-cell", 16);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var doc_r9 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(doc_r9.fileName);
} }
function SupplierSharedDocsListComponent_mat_table_5_mat_header_cell_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-cell");
} }
function SupplierSharedDocsListComponent_mat_table_5_mat_cell_6_Template(rf, ctx) { if (rf & 1) {
    var _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-cell", 17);
    i0.ɵɵelementStart(1, "button", 18);
    i0.ɵɵlistener("click", function SupplierSharedDocsListComponent_mat_table_5_mat_cell_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r12); var doc_r10 = ctx.$implicit; var ctx_r11 = i0.ɵɵnextContext(2); return ctx_r11.view(doc_r10); });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "lbl_view"));
} }
function SupplierSharedDocsListComponent_mat_table_5_mat_header_row_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-header-row");
} }
function SupplierSharedDocsListComponent_mat_table_5_mat_row_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "mat-row", 19);
} if (rf & 2) {
    var doc_r13 = ctx.$implicit;
    i0.ɵɵproperty("ghExtInfiniteRow", doc_r13);
} }
function SupplierSharedDocsListComponent_mat_table_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-table", 6);
    i0.ɵɵelementContainerStart(1, 7);
    i0.ɵɵtemplate(2, SupplierSharedDocsListComponent_mat_table_5_mat_header_cell_2_Template, 3, 3, "mat-header-cell", 8);
    i0.ɵɵtemplate(3, SupplierSharedDocsListComponent_mat_table_5_mat_cell_3_Template, 2, 1, "mat-cell", 9);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementContainerStart(4, 10);
    i0.ɵɵtemplate(5, SupplierSharedDocsListComponent_mat_table_5_mat_header_cell_5_Template, 1, 0, "mat-header-cell", 11);
    i0.ɵɵtemplate(6, SupplierSharedDocsListComponent_mat_table_5_mat_cell_6_Template, 4, 3, "mat-cell", 12);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵtemplate(7, SupplierSharedDocsListComponent_mat_table_5_mat_header_row_7_Template, 1, 0, "mat-header-row", 13);
    i0.ɵɵtemplate(8, SupplierSharedDocsListComponent_mat_table_5_mat_row_8_Template, 1, 1, "mat-row", 14);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r0 = i0.ɵɵnextContext();
    var _r2 = i0.ɵɵreference(8);
    i0.ɵɵproperty("dataSource", ctx_r0.dataSource)("tracker", _r2)("trackBy", ctx_r0.getDocId);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("matHeaderRowDef", ctx_r0.displayedColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("matRowDefColumns", ctx_r0.displayedColumns);
} }
function SupplierSharedDocsListComponent_div_6_mat_card_2_Template(rf, ctx) { if (rf & 1) {
    var _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "mat-card");
    i0.ɵɵelementStart(1, "mat-card-content");
    i0.ɵɵelementStart(2, "div", 23);
    i0.ɵɵelementStart(3, "div", 24);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 25);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "mat-card-actions", 26);
    i0.ɵɵelementStart(9, "button", 18);
    i0.ɵɵlistener("click", function SupplierSharedDocsListComponent_div_6_mat_card_2_Template_button_click_9_listener() { i0.ɵɵrestoreView(_r17); var doc_r15 = ctx.$implicit; var ctx_r16 = i0.ɵɵnextContext(2); return ctx_r16.view(doc_r15); });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var doc_r15 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(5, 3, "lbl_file_name"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(doc_r15.fileName);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 5, "lbl_view"));
} }
function SupplierSharedDocsListComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20);
    i0.ɵɵelementStart(1, "gh-ext-infinite-list", 21);
    i0.ɵɵtemplate(2, SupplierSharedDocsListComponent_div_6_mat_card_2_Template, 12, 7, "mat-card", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    var ctx_r1 = i0.ɵɵnextContext();
    var _r2 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("itemHeight", 170)("tracker", _r2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ghExtInfiniteScrollForOf", ctx_r1.dataSource);
} }
var SupplierSharedDocsListComponent = /** @class */ (function () {
    function SupplierSharedDocsListComponent(route, businessService) {
        this.route = route;
        this.businessService = businessService;
        this.displayedColumns = ['fileName', 'fileId'];
    }
    SupplierSharedDocsListComponent.prototype.ngOnInit = function () {
        this.subscribeToNavigation();
    };
    SupplierSharedDocsListComponent.prototype.getDocId = function (index, doc) {
        return doc.fileId;
    };
    SupplierSharedDocsListComponent.prototype.view = function (doc) {
        openInNewWindow(doc.fileUrl);
    };
    SupplierSharedDocsListComponent.prototype.loadDocs = function () {
        this.dataSource = InfiniteMatDataSource.wrap(this.businessService.getAll());
        this.dataSource.sort = this.sort;
    };
    SupplierSharedDocsListComponent.prototype.subscribeToNavigation = function () {
        var _this = this;
        this.route
            .params
            .subscribe(function () { return _this.loadDocs(); });
    };
    SupplierSharedDocsListComponent.ɵfac = function SupplierSharedDocsListComponent_Factory(t) { return new (t || SupplierSharedDocsListComponent)(i0.ɵɵdirectiveInject(i1.ActivatedRoute), i0.ɵɵdirectiveInject(i2.SupplierSharedDocsListBusinessService)); };
    SupplierSharedDocsListComponent.ɵcmp = i0.ɵɵdefineComponent({ type: SupplierSharedDocsListComponent, selectors: [["gh-shared-docs"]], viewQuery: function SupplierSharedDocsListComponent_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(MatSort, true);
        } if (rf & 2) {
            var _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sort = _t.first);
        } }, decls: 9, vars: 5, consts: [[3, "title"], ["matSort", ""], ["ghExtInfiniteTable", "", 3, "dataSource", "tracker", "trackBy", 4, "ghExtIfQuery"], ["fxLayout", "column", 4, "ghExtIfQuery"], ["fxFlex", ""], ["tracker", "ghExtLoadTracker"], ["ghExtInfiniteTable", "", 3, "dataSource", "tracker", "trackBy"], ["matColumnDef", "fileName"], ["fxFlex", "75%", "mat-sort-header", "", 4, "matHeaderCellDef"], ["fxFlex", "75%", 4, "matCellDef"], ["matColumnDef", "fileId"], [4, "matHeaderCellDef"], ["class", "cell-align-right", 4, "matCellDef"], [4, "matHeaderRowDef"], [3, "ghExtInfiniteRow", 4, "matRowDef", "matRowDefColumns"], ["fxFlex", "75%", "mat-sort-header", ""], ["fxFlex", "75%"], [1, "cell-align-right"], ["type", "button", "mat-stroked-button", "", 1, "small", "cell-button", 3, "click"], [3, "ghExtInfiniteRow"], ["fxLayout", "column"], [3, "itemHeight", "tracker"], [4, "ghExtInfiniteScrollFor", "ghExtInfiniteScrollForOf"], [1, "card-content-item"], [1, "card-content-item-title"], [1, "card-content-item-value"], [1, "right"]], template: function SupplierSharedDocsListComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "gh-ext-page");
            i0.ɵɵelement(1, "gh-ext-page-title", 0);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵelementStart(3, "gh-ext-page-content");
            i0.ɵɵelementContainerStart(4, 1);
            i0.ɵɵtemplate(5, SupplierSharedDocsListComponent_mat_table_5_Template, 9, 5, "mat-table", 2);
            i0.ɵɵtemplate(6, SupplierSharedDocsListComponent_div_6_Template, 3, 3, "div", 3);
            i0.ɵɵelement(7, "gh-ext-load-tracker", 4, 5);
            i0.ɵɵelementContainerEnd();
            i0.ɵɵelementEnd();
            i0.ɵɵelementEnd();
        } if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 3, "lbl_shared_documents"));
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ghExtIfQuery", "gt-sm");
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ghExtIfQuery", "lt-md");
        } }, directives: [i3.ExtPageComponent, i3.ExtPageTitleDirective, i3.ExtPageContentComponent, i4.MatSort, i5.ExtIfQueryDirective, i6.ExtLoadTrackerComponent, i7.DefaultFlexDirective, i8.MatTable, i9.ExtInfiniteTableDirective, i10.ExtInfiniteTableViewerDirective, i8.MatColumnDef, i8.MatHeaderCellDef, i8.MatCellDef, i8.MatHeaderRowDef, i8.MatRowDef, i8.MatHeaderCell, i4.MatSortHeader, i8.MatCell, i11.MatButton, i8.MatHeaderRow, i8.MatRow, i12.ExtInfiniteRowDirective, i7.DefaultLayoutDirective, i13.ExtInfiniteListComponent, i14.ExtInfiniteScrollForDirective, i15.MatCard, i15.MatCardContent, i15.MatCardActions], pipes: [i16.TranslatePipe], encapsulation: 2 });
    return SupplierSharedDocsListComponent;
}());
export { SupplierSharedDocsListComponent };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierSharedDocsListComponent, [{
        type: Component,
        args: [{
                selector: 'gh-shared-docs',
                templateUrl: 'supplier-shared-docs-list.component.html',
            }]
    }], function () { return [{ type: i1.ActivatedRoute }, { type: i2.SupplierSharedDocsListBusinessService }]; }, { sort: [{
            type: ViewChild,
            args: [MatSort, { static: false }]
        }] }); })();
